import { useState } from 'react';
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import Input from "components/Input/Input";

const PasswordField = ({ defaulValue, onChange, label='', id, name }) => {
  const [isShowPassword, setIsShowPassword] = useState(false);

  return (
    <div className="relative">
      <Input
        label={label}
        isMediumFont={true}
        id={id}
        name={name}
        defaultValue={defaulValue}
        type={isShowPassword ? 'text' : 'password'}
        required={true}
        onChange={onChange}
        autoComplete="current-password"
        className="pr-10"
      />
      <button
        type="button"
        className="absolute right-3 bottom-[9px] text-muted-foreground hover:text-foreground transition-colors"
        onClick={() => setIsShowPassword(!isShowPassword)}
        tabIndex={-1}
      >
        {isShowPassword
          ? <EyeSlashIcon className="h-4 w-4" />
          : <EyeIcon className="h-4 w-4" />
        }
      </button>
    </div>
  )
}

export default PasswordField;